export default function initFiltersWrapper(): void {
    const $filtersWrapper = document.querySelectorAll<HTMLElement>('.js-filters-wrapper');
    $filtersWrapper.forEach($container => {
        new FiltersWrapper($container);
    });
}

class FiltersWrapper {
    $el: HTMLElement | null | undefined;
    $filterMobileButton: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$filterMobileButton = this.$el?.querySelector('.js-filter-mobile-button');
        this.init();
    }

    init(): void {
        const resetAllFiltersBtn = this.$el?.querySelectorAll('.js-reset-filters');

        this.$filterMobileButton?.addEventListener('click', () => {
            this.$filterMobileButton?.classList.toggle('open');
        });

        // Ajout de l'écouteur d'événement pour la touche Escape
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                this.$filterMobileButton?.classList.remove('open');
            }
        });

        document.addEventListener('DOMContentLoaded', () => {
            const checkboxes = this.$el?.querySelectorAll('input');
            
            const updateresetAllFiltersBtnVisibility = () => {
                if (!resetAllFiltersBtn || !checkboxes) return;
                // Vérifie si au moins un checkbox est coché
                const isChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
                resetAllFiltersBtn.forEach((resetbtn: Element) => {
                    if (isChecked) {
                        resetbtn.classList.add('visible');
                    } else {
                        resetbtn.classList.remove('visible');
                    }
                });
              };
            
              // Ajoute un écouteur sur chaque checkbox pour détecter les changements
              checkboxes?.forEach(checkbox => {
                checkbox.addEventListener("change", updateresetAllFiltersBtnVisibility);
              });
            
              // Vérification initiale au chargement de la page
              updateresetAllFiltersBtnVisibility();
        });

        // Bouton reset de tout les filtres
        if (resetAllFiltersBtn) {
            resetAllFiltersBtn.forEach((resetBtn: Element) => {
                resetBtn.addEventListener('click', () => {
                    
                    const inputs = this.$el?.querySelectorAll('input');
                    if (inputs) {
                        inputs.forEach((input: HTMLInputElement) => {
                            if (input.type === 'checkbox' || input.type === 'radio') {
                                input.checked = false;
                            } else {
                                input.value = '';
                            }
                        });
                    }

                    this.$el?.querySelector('form')?.submit();
                });
            });
        }
    }
}
